import { Card, CardContent, CardMedia } from '@mui/material'
import React, { ComponentPropsWithoutRef, useCallback, useState } from 'react'
import placeholder from '../../../../assets/video_placeholder.png'

interface ContentCardProps extends ComponentPropsWithoutRef<'div'> {
  image?: JSX.Element | string
}
export function ContentCard({ children, image, ...props }: ContentCardProps) {
  const [hoverState, setHoverState] = useState<boolean>(false)

  const RenderImage = useCallback(() => {
    if (!image || typeof image === 'string') {
      const imageRoute = image || placeholder
      return <CardMedia component="img" image={imageRoute} alt="card image" sx={{ ':hover': { cursor: 'pointer' } }} />
    }
    return image
  }, [image])

  return (
    <Card elevation={hoverState ? 10 : 1} onMouseOver={() => setHoverState(true)} onMouseLeave={() => setHoverState(false)} {...props}>
      {/* <RenderImage /> */}
      <CardContent sx={{ paddingBottom: '16px !important' }}>{children}</CardContent>
    </Card>
  )
}

ContentCard.defaultProps = {
  image: '',
}
